<!-- 日期搜索框 -->
<template>
  <div class="myDate">
    <el-select
      v-model="yearsModel"
      @change="dateChange(1)"
      placeholder="请选择"
      size="small"
      style="width: 100px"
    >
      <el-option
        v-for="item in years"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
    <span>~</span>
    <el-select
      v-model="monthsModel"
      @change="dateChange(2)"
      placeholder="请选择"
      style="width: 100px; margin-left: 10px"
      size="small"
    >
      <el-option
        v-for="item in months"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    parentYear: {
      type: Number
    },
    parentMonth: {
      type: Number
    }
  },
  data() {
    return {
      yearsModel: null,
      years: [],
      monthsModel: null,
      months: [],
      daysModel: null,
      days: []
    }
  },

  watch: {
    parentYear: {
      handler: function (newVal) {
        if (newVal) {
          this.yearsModel = newVal
        }
      },
      immediate: true
    },
    parentMonth: {
      handler: function (newVal) {
        if (newVal) {
          this.monthsModel = newVal
        }
      },
      immediate: true
    }
  },

  created() {
    console.log(this.parentYear)
    this.init()
  },
  methods: {
    init() {
      //   let myDate = new Date()
      let year = 0
      this.initSelectYear(year)
      this.initSelectMonth()
    },
    initSelectYear(year) {
      this.years = [{ label: '不限', value: 0 }]
      for (let i = 18; i < 60; i++) {
        this.years.push({ value: year + i, label: year + i })
      }
    },
    initSelectMonth() {
      if (this.yearsModel > 0) {
        this.months = []
        for (let i = this.yearsModel + 1; i <= 70; i++) {
          this.months.push({ value: i, label: i })
        }
      } else {
        this.months = [{ label: '不限', value: 0 }]
      }
    },
    dateChange(type) {
      if (type == 1) {
        if (this.yearsModel == 0) {
          this.monthsModel = 0
        }
        this.initSelectMonth()
      }
      this.$emit('dateChange', this.yearsModel, this.monthsModel)
    }
  }
}
</script>

<style lang="less" scoped>
.myDate {
  .el-select {
    margin-right: 10px;
  }
}
/deep/ .el-input__inner {
  border: 1px solid #17757a;
  height: 36px;
  line-height: 36px;
}
/deep/ .el-input__inner:hover {
  border-color: #17757a;
}
</style>
